<template>
    <div id="internalFailure">

        <v-stepper-content step="5">

            <v-jumbotron color="#775DD0" dark>
                <v-container fill-height>
                    <v-layout align-center>
                        <v-flex text-xs-center>
                            <h4 class="display-1">Other Types of Waste</h4>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <!-- DEFECTS REWORK -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.defectsRework class="subcost" @click="visible.defectsRework = !visible.defectsRework">Defects / Rework</v-btn>
            </v-layout>

            <v-layout row wrap justify-space-around v-if="visible.defectsRework">
                <v-flex class="cell" v-for="(cost, i) in other.defectsRework" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('defectsRework')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- OVER PRODUCTION -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.overproduction class="subcost" @click="visible.overproduction = !visible.overproduction">Overproduction</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.overproduction">
                <v-flex class="cell" v-for="(cost, i) in other.overproduction" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('overproduction')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- WAITING -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.waiting class="subcost" @click="visible.waiting = !visible.waiting">Waiting</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.waiting">
                <v-flex class="cell" v-for="(cost, i) in other.waiting" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('waiting')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- NON UTILIZED TALENTS SKILLS -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.nonUtilizedTalentsSkills class="subcost" @click="visible.nonUtilizedTalentsSkills = !visible.nonUtilizedTalentsSkills">Non Utilized Talents Skills</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.nonUtilizedTalentsSkills">
                <v-flex class="cell" v-for="(cost, i) in other.nonUtilizedTalentsSkills" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('nonUtilizedTalentsSkills')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- TRANSPORTATION -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.transportation class="subcost" @click="visible.transportation = !visible.transportation">Transportation</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.transportation">
                <v-flex class="cell" v-for="(cost, i) in other.transportation" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('transportation')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- INVENTORY -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.inventory class="subcost" @click="visible.inventory = !visible.inventory">Inventory</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.inventory">
                <v-flex class="cell" v-for="(cost, i) in other.inventory" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('inventory')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- MOTION -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.motion class="subcost" @click="visible.motion = !visible.motion">Motion</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.motion">
                <v-flex class="cell" v-for="(cost, i) in other.motion" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('motion')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- EXTRA PROCESSING -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.extraProcessing class="subcost" @click="visible.extraProcessing = !visible.extraProcessing">Extra Processing</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.extraProcessing">
                <v-flex class="cell" v-for="(cost, i) in other.extraProcessing" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('extraProcessing')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <br>
            <h2>Total Other Costs: ${{ total }}</h2>
            <br>

            <v-btn flat @click.native="$emit('previous-step')">Previous</v-btn>
            <v-btn color="primary" @click.native="$emit('sections-complete', [other, 'other'])">Submit</v-btn>

        </v-stepper-content>

    </div>
</template>

<script>
    export default {
        name: 'internalFailure',
        props: [
            'total',
            'visible',
            'verified'
        ],
        data: () => ({
            errors: [],
            otherTotal: 0,
            otherSubTotals: {
                defectsRework: 0,
                overproduction: 0,
                waiting: 0,
                nonUtilizedTalentsSkills: 0,
                transportation: 0,
                inventory: 0,
                motion: 0,
                extraProcessing: 0
            },
            other: {
                defectsRework: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                overproduction: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                waiting: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                nonUtilizedTalentsSkills: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                transportation: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                inventory: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                motion: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                extraProcessing: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ]
            }
        }),
        methods: {
            calculateSubTotal(subCost) {
                let newTotal = 0;
                this.other[subCost].forEach(cost => {
                    if(cost.value) {
                        newTotal += parseInt(cost.value);
                    }
                })
                this.otherSubTotals[subCost] = newTotal;
                this.calculateTotal();
            },
            calculateTotal() {
                let newTotal = 0;
                for(let key in this.otherSubTotals) {
                    newTotal += this.otherSubTotals[key]
                }
                this.otherTotal = newTotal;
                this.$emit('update-total', [this.otherTotal, 'other']);
            }
        },
        created: function() {
            // Add tests upon initial load here
        }
    }
</script>

<style scoped>
</style>

